import React from "react";
import Page from "@jumbo/shared/Page";
// import Home from "../pages/home";
import WebViewLogin from "app/pages/webViewLogin/WebViewLogin";
import WebViewProfile from "app/pages/webViewProfile/WebViewProfile";
import WebViewRegistrasi from "app/pages/webViewRegistrasi/WebViewRegistrasi";
import WebViewOtpVerification from "app/pages/webViewOtpVerification/WebViewOtpVerification";
import WebViewRegistrasiSukses from "app/pages/webViewRegistrasiSukses/WebViewRegistrasiSukses";
import WebViewHomepageRefealProgram from "app/pages/webViewHomepageRefealProgram/WebViewHomepageRefealProgram";
import WebViewAddReffSukses from "app/pages/webViewAddReffSukses/WebViewAddReffSukses";
import WebViewTncReff from "app/pages/webViewTncReff/WebViewTncReff";
import WebViewAddRefferal from "app/pages/webViewAddRefferal/WebViewAddRefferal";
import WebViewRefferalDetail from "app/pages/webViewRefferalDetail/WebViewRefferalDetail";
import MicrositeLogin from "app/pages/micrositeLogin/MicrositeLogin";
import MicrositeListLeads from "app/pages/micrositeListLeads/MicrositeListLeads";
import MicrositeNews from "app/pages/micrositeNews/MicrositeNews";
import MicrositeHistoryPayment from "app/pages/micrositeHistoryPayment/MicrositeHistoryPayment";
import MicrositeDokument from "app/pages/micrositeDocument/MicrositeDocument";
import MicrositeAddLeads from "app/pages/micrositeAddLeads/MicrositeAddLeads";
import MicrositeSuksesAddLeads from "app/pages/micrositeSuksesAddLeads/MicrositeSuksesAddLeads";
import MicrositeLupaPassword from "app/pages/micrositeLupaPassword/MicrositeLupaPassword";
import MicrositeSyaratKetentuan from "app/pages/micrositeSyaratKetentuan/MicrositeSyaratKetentuan";
import MicrositeKonfirmasiUbahPassword from "app/pages/micrositeKonfirmasiUbahPassword/MicrositeKonfirmasiUbahPassword";
import MicrositeKonfirmasiLupaPassword from "app/pages/micrositeKonfirmasiLupaPassword/MicrositeKonfirmasiLupaPassword";
import MicrositeUbahPassword from "app/pages/micrositeUbahPassword/MicrositeUbahPassword";
import MicrositeOtp from "app/pages/micrositeOtp/MicrositeOtp";
import MfaChoice from "app/pages/mfaChoice/MfaChoice";
import VerifyMfa from "app/pages/verifyMfa/VerifyMfa";
import MicrositeKonfirmasiSuksesRegis from "app/pages/micrositeKonfirmasiSuksesRegis/MicrositeKonfirmasiSuksesRegis";
import MicrositeKonfirmasiBelumRegis from "app/pages/micrositeKonfirmasiBelumRegis/MicrositeKonfirmasiBelumRegis";
import MicrositeTnCRegis from "app/pages/micrositeTnCRegis/MicrositeTnCRegis";
import MicrositeProfile from "app/pages/micrositeProfile/MicrositeProfile";
import { Navigate } from "react-router-dom";
import PageNotFound from "app/pages/404/PageNotFound";
import MicrositeHistoryPaymentPerLead from "app/pages/micrositeHistoryPaymentPerLead/MicrositeHistoryPaymentPerLead";
import WebviewAddReferrerTerminated from "app/pages/webviewAddReferrerTerminated/WebviewAddReferrerTerminated";
import WebviewEditReferrer from "app/pages/webviewEditReferrer/WebviewEditReferrer";
import MicrositeProfileEdit from "app/pages/micrositeProfileEdit/MicrositeProfileEdit";
// import Test from "app/pages/test/Test";
/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/

const SOLO = 'solo-page'
const PUBLIC = 'public-page'

const routesForPublic = [
  {
    path: "/",
    element: <Navigate to={"/micrositeLogin"} />
  },
  {
    path: "/404",
    element: <Page component={PageNotFound} layout={PUBLIC} />
  },
  {
    path: "/micrositeLupaPassword",
    element: <Page component={MicrositeLupaPassword} layout={SOLO} />
  },

];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
  {
    path: "/",
    element: <Navigate to={"/micrositeNews"} />
  },
  {
    path: "/micrositeSyaratKetentuan",
    element: <Page component={MicrositeSyaratKetentuan} layout={SOLO} />
  },
  {
    path: "/micrositeProfile",
    element: <Page component={MicrositeProfile} layout={SOLO} />
  },
  {
    path: "/micrositeProfileEdit",
    element: <Page component={MicrositeProfileEdit} layout={SOLO} />
  },
  {
    path: "/micrositeListLeads",
    element: <Page component={MicrositeListLeads} layout={"private-page"} />
  },
  {
    path: "/micrositeNews",
    element: <Page component={MicrositeNews} layout={"private-page"} />
  },
  {
    path: "/micrositeHistoryPayment",
    element: <Page component={MicrositeHistoryPayment} layout={"private-page"} />
  },
  {
    path: "/micrositeHistoryPaymentPerLead",
    element: <Page component={MicrositeHistoryPaymentPerLead} layout={"private-page"} />
  },
  {
    path: "/micrositeDokument",
    element: <Page component={MicrositeDokument} layout={"private-page"} />
  },
  {
    path: "/micrositeAddLeads",
    element: <Page component={MicrositeAddLeads} layout={"private-page"} />
  },
  {
    path: "/micrositeSuksesAddLeads",
    element: <Page component={MicrositeSuksesAddLeads} layout={"private-page"} />
  },
  {
    path: "/micrositeUbahPassword",
    element: <Page component={MicrositeUbahPassword} layout={PUBLIC} />
  },
  {
    path: "/micrositeOtp",
    element: <Page component={MicrositeOtp} layout={PUBLIC} />
  },
  {
    path: "/mfaChoice",
    element: <Page component={MfaChoice} layout={PUBLIC} />
  },
  {
    path: "/verifyMfa",
    element: <Page component={VerifyMfa} layout={PUBLIC} />
  },
  {
    path: "/micrositeOtpLoggedIn",
    element: <Page component={MicrositeOtp} layout={SOLO} />
  },
  {
    path: "/micrositeKonfirmasiUbahPassword",
    element: <Page component={MicrositeKonfirmasiUbahPassword} layout={SOLO} />
  },
  {
    path: "/micrositeKonfirmasiLupaPassword",
    element: <Page component={MicrositeKonfirmasiLupaPassword} layout={PUBLIC} />
  },
  {
    path: "/micrositeKonfirmasiBelumRegis",
    element: <Page component={MicrositeKonfirmasiBelumRegis} layout={PUBLIC} />
  },
  {
    path: "/micrositeKonfirmasiSuksesRegis",
    element: <Page component={MicrositeKonfirmasiSuksesRegis} layout={PUBLIC} />
  },
  {
    path: "/micrositeTnCRegis",
    element: <Page component={MicrositeTnCRegis} layout={PUBLIC} />
  },
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [
  {
    path: "/micrositeLogin",
    element: <Page component={MicrositeLogin} layout={PUBLIC} />
  },
  // {
  //   path: "/test",
  //   element: <Page component={Test} layout={PUBLIC} />
  // },
  {
    path: "/webViewReRegis",
    element: <Page component={WebviewAddReferrerTerminated} isWebview layout={SOLO} />
  },
  {
    path: "/webViewLogin",
    element: <Page component={WebViewLogin} isWebview layout={SOLO} />
  },
  {
    path: "/webViewProfile",
    element: <Page component={WebViewProfile} layout={SOLO} />
  },
  /* webview agent */
  {
    path: "/webViewRegistrasi",
    element: <Page component={WebViewRegistrasi} isWebview layout={SOLO} />
  },
  {
    path: "/webViewOtpVerification",
    element: <Page component={WebViewOtpVerification} isWebview layout={SOLO} />
  },
  {
    path: "/webViewRegistrasiSukses",
    element: <Page component={WebViewRegistrasiSukses} isWebview layout={SOLO} />
  },
  /* webview referrer */
  {
    path: "/referrerList",
    element: <Page component={WebViewHomepageRefealProgram} isWebview layout={SOLO} />
  },
  {
    path: "/webViewAddReffSukses",
    element: <Page component={WebViewAddReffSukses} isWebview layout={SOLO} />
  },
  {
    path: "/webviewEditReferrer",
    element: <Page component={WebviewEditReferrer} isWebview layout={SOLO} />
  },
  {
    path: "/webViewAddRefferal",
    element: <Page component={WebViewAddRefferal} isWebview layout={SOLO} />
  },
  {
    path: "/webViewRefferalDetail",
    element: <Page component={WebViewRefferalDetail} isWebview layout={SOLO} />
  },
  /* webview tnc */
  {
    path: "/termAndCondition",
    element: <Page component={WebViewTncReff} isWebview layout={SOLO} />
  },
];

export const webviewPages = [
  {
    path: "/webViewLogin",
    element: <Page component={WebViewLogin} layout={SOLO} />
  },
  {
    path: "/webViewReRegis",
    element: <Page component={WebviewAddReferrerTerminated} isWebview layout={SOLO} />
  },
  {
    path: "/webViewProfile",
    element: <Page component={WebViewProfile} layout={SOLO} />
  },
  /* webview agent */
  {
    path: "/webViewRegistrasi",
    element: <Page component={WebViewRegistrasi} layout={SOLO} />
  },
  {
    path: "/webViewOtpVerification",
    element: <Page component={WebViewOtpVerification} layout={SOLO} />
  },
  {
    path: "/webViewRegistrasiSukses",
    element: <Page component={WebViewRegistrasiSukses} layout={SOLO} />
  },
  /* webview referrer */
  {
    path: "/referrerList",
    element: <Page component={WebViewHomepageRefealProgram} layout={SOLO} />
  },
  {
    path: "/webViewAddReffSukses",
    element: <Page component={WebViewAddReffSukses} layout={SOLO} />
  },
  {
    path: "/webViewAddRefferal",
    element: <Page component={WebViewAddRefferal} layout={SOLO} />
  },
  {
    path: "/webviewEditReferrer",
    element: <Page component={WebviewEditReferrer} isWebview layout={SOLO} />
  },
  {
    path: "/webViewRefferalDetail",
    element: <Page component={WebViewRefferalDetail} layout={SOLO} />
  },
  /* webview tnc */
  {
    path: "/termAndCondition",
    element: <Page component={WebViewTncReff} layout={SOLO} />
  },
]


const routes = [
  ...routesForPublic,
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export { routes as default, routesForPublic, routesForNotAuthenticatedOnly, routesForAuthenticatedOnly };